/**
 * Manage subscribed users (add/edit/delete) , send email to subscribed user with current connection link and generate current connection  pdf.
 */

import React from 'react';
import { connect } from 'react-redux';
import CKEditor from 'ckeditor4-react';
import cx from 'classnames';
import { bindActionCreators } from 'redux';
import { Row, Col, Form } from 'react-bootstrap';
import * as moment from 'moment';
import * as _ from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { NotificationManager } from 'react-notifications';
import { ConnectionPdfs } from '../../admin';
import * as adminActions from '../../../store/admin';
import * as portalActions from '../../../store/portal';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-notifications/lib/notifications.css';
import { utilService } from '../../../common/utils';
import { DialogBox } from '../../../common/dialogbox';
// import { ApiService } from '../../../common/services/api.service';
import { config } from '../../../config/config';

class SubscribedUsers extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSaveSubscriber = this.handleSaveSubscriber.bind(this);
    this.onReset = this.onReset.bind(this);
    this.actionsButtonFormatter = this.actionsButtonFormatter.bind(this);
    this.onFilter = this.onFilter.bind(this);

    this.state = {
      subscribedUser: {},
      editSubscriber: false,
      modal_data: {
        show: false,
        pdfEmailText: {},
      },
      pdfs: [],
      filterData: {},
      errors: {},
      pdf_status: '',
      created_pdf_obj: null,
      downloading_pdf: false,
      isLoading: false,
      isSaving: false,
      isReseting: false,
      isFiltering: false,
      isDeleting: false,
      deleteModel: null,
      openModel: null,
    };
  }
  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // Fetch subscribed users list
    this.props.getSubscribedUsers({
      token: this.props.token,
      params: '',
    });
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps Getting previous props
   * @param {*} prevState Getting previous state
   */
  componentDidUpdate(prevProps, prevState) {
    // Show success notification when data saved successfully
    if (
      (prevProps.subscribedUserActionLoading &&
        !this.props.subscribedUserActionLoading) ||
      (prevProps.pdfActionLoading && !this.props.pdfActionLoading)
    ) {
      if (prevState.isSaving) {
        // Show error notification
        if (prevProps.error !== this.props.error) {
          if (this.props.error) {
            this.setState({
              ...this.state,
              isLoading: false,
              isSaving: false,
            })
            NotificationManager.error(this.props.error);
          }
        } else {
          this.setState(
            {
              ...this.state,
              subscribedUser: {},
              errors: {},
              isLoading: false,
              isSaving: false,
              editSubscriber: false,
            },
            function () {
              NotificationManager.success(
                'Success message',
                'Saved successfully.'
              );
            }
          );
        }
      }

      // Show success delete notification when deleted successfully
      if (prevState.isDeleting) {
        this.setState(
          {
            ...this.state,
            errors: {},
            isLoading: false,
            isSaving: false,
            isDeleting: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Deleted successfully.'
            );
          }
        );
      }

      // Hide progress on filter button, when filtered complete
      if (prevState.isFiltering) {
        this.setState(
          {
            ...this.state,
            errors: {},
            isLoading: false,
            isSaving: false,
            isDeleting: false,
            isFiltering: false,
          },
          function () {}
        );
      }
    }
  }

  /**
   * Handel input change event
   * @param {*} dict Dictionary name
   * @param {*} e Form event
   */
  handleInputChange(dict, e) {
    const { name, value } = e.target;
    // console.log(name, value)
    let fields = this.state[dict];
    fields[name] = value;
    this.setState({
      fields,
    });
  }

  /**
   * Validate form before submitting data
   */
  validateForm() {
    let fields = this.state.subscribedUser;
    let errors = {};
    let formIsValid = true;

    if (!fields['name']) {
      formIsValid = false;
      errors['name'] = '*Please enter name.';
    }
    if (!fields['email']) {
      formIsValid = false;
      errors['email'] = '*Please enter email.';
    }

    if (fields['email']) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(fields['email'].toLowerCase())) {
        formIsValid = false;
        errors['invalid_email'] = '*Please enter valid email.';
      }
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  /**
   * Handel close event of popup model
   */
  handleCloseModal() {
    // console.log(this.state);
    this.setState({
      ...this.state,
      openModel: null,
      modal_data: {
        ...this.state.modal_data,
        show: false,
      },
    });
  }

  /**
   * Handel submit event of popup model and call delete api
   * @param {*} id
   */
  OnDialogSubmit(id) {
    this.setState(
      {
        ...this.state,
        modal_data: {
          ...this.state.modal_data,
          show: false,
        },
        isLoading: true,
        isDeleting: true,
      },
      function () {
        if (this.state.deleteModel && this.state.deleteModel === 'pdf') {
          this.props.deletePdf({
            id: id,
            token: this.props.token,
          });
        } else {
          this.props.deleteSubscribedUser({
            id: id,
            token: this.props.token,
          });
        }
      }
    );
  }

  savePdfEmailText() {}

  /**
   * Get Subscribed users based on passed parametes
   * Set query string parameters and call api with parameters
   * @param {*} e Form event
   */
  onFilter(e) {
    e.preventDefault();

    let fields = this.state.filterData;
    let params = '?';

    if (fields['name']) {
      if (params !== '?') {
        params = params + '&';
      }
      params = params + `name=${fields['name']}`;
    }
    if (fields['email']) {
      if (params !== '?') {
        params = params + '&';
      }
      params = params + `email=${fields['email']}`;
    }

    if (params === '?') {
      params = '';
    }

    this.setState({
      isLoading: true,
      isFiltering: true,
      isReseting: false,
    });

    this.props.getSubscribedUsers({
      token: this.props.token,
      params: params,
    });
  }

  /**
   * Function is created to edit/update subscribed user when click on edit button
   * @param {*} cell cell value
   * @param {*} row  row object
   * @param {*} rowIndex index of row
   */
  onEditSubscribedUser(cell, row, rowIndex) {
    if (row.subscribedusersUid) {
      this.setState({
        ...this.state,
        subscribedUser: row,
        editSubscriber: true,
      });
    }
  }

  /**
   * Open popup dialog when click on delete subscribed user
   * @param {*} cell
   * @param {*} row
   * @param {*} rowIndex
   */
  onDeleteSubscribedUser(cell, row, rowIndex) {
    if (row.subscribedusersUid) {
      this.setState({
        ...this.state,
        deleteModel: 'subscribedUser',
        modal_data: {
          ...this.state.modal_data,
          show: true,
          data: {
            heading: 'Delete subscribed user',
            body:
              'Are you sure you want to permanetly remove this subscribed user ?',
            rowId: row.subscribedusersUid,
          },
        },
      });
    }
  }

  /**
   * Handel reset event and fetch subscribed uses
   * @param {*} form_name provide form name which need to reset
   * @param {*} e Form event
   */
  onReset(form_name, e) {
    e.preventDefault();
    if (form_name === 'subscribedUserForm') {
      this.setState({
        ...this.state,
        subscribedUser: {},
        modal_data: {
          show: false,
        },
        editSubscriber: false,
        errors: {},
        isLoading: false,
        isSaving: false,
        isDeleting: false,
        isFiltering: false,
      });
    } else {
      this.setState({
        ...this.state,
        filterData: {},
        modal_data: {
          show: false,
        },
        editSubscriber: false,
        errors: {},
        isLoading: false,
        isSaving: false,
        isDeleting: false,
        isFiltering: false,
      });

      this.props.getSubscribedUsers({
        token: this.props.token,
        params: '',
      });
    }

    // this[form_name].reset();
  }

  /**
   * Show action buttons on subscribed user table
   * @param {*} cell
   * @param {*} row
   * @param {*} enumObject
   * @param {*} rowIndex
   */
  actionsButtonFormatter(cell, row, rowIndex) {
    return (
      <div className="d-flex align-items-center nav-con">
        <button
          type="button"
          className="btn btn-dark lh-0 p-3"
          onClick={this.onEditSubscribedUser.bind(this, cell, row, rowIndex)}
          title="Edit Subscriber"
        >
          <i className="fa fa-pencil fa-w-16" aria-hidden="true" />
        </button>
        <button
          type="button"
          className="btn btn-primary lh-0 p-3"
          onClick={this.onDeleteSubscribedUser.bind(this, cell, row, rowIndex)}
          title="Delete Subscriber"
        >
          <i className="fa fa-trash fa-w-16" aria-hidden="true" />
        </button>
      </div>
    );
  }

  openSendEmailDialog(cell, row, rowIndex) {
    if (row.connections_pdfUid) {
      this.setState({
        ...this.state,
        openModel: 'email-dialog',
        modal_data: {
          ...this.state.modal_data,
          show: true,
          data: {
            heading: 'Send Email',
            rowId: row.connections_pdfUid,
          },
        },
      });
    }
  }

  /**
   * Submit form data
   * @param {*} e
   */
  handleSaveSubscriber(e) {
    e.preventDefault();
    if (this.validateForm()) {
      // console.log(this.state.subscribedUser);
      if (this.state.subscribedUser.subscribedusersUid) {
        let fields = this.state.subscribedUser;
        fields['updated_at'] = new Date();

        this.setState({
          fields,
          isLoading: true,
          isSaving: true,
        });

        this.props.updateSubscribedUser({
          token: this.props.token,
          data: this.state.subscribedUser,
        });
      } else {
        let fields = this.state.subscribedUser;
        fields['created_at'] = new Date();
        fields['updated_at'] = new Date();
        fields['users_userid'] = this.props.user.userUid;
        fields['users_username'] = this.props.user.username;
        fields['users_firstname'] = this.props.user.firstname;
        fields['users_lastname'] = this.props.user.surname;

        this.setState({
          fields,
          isLoading: true,
          isSaving: true,
        });

        this.props.saveSubscribedUser({
          token: this.props.token,
          data: this.state.subscribedUser,
        });
      }
    }
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    const { subscribedUsers } = this.props;
    const columns = [
      {
        dataField: 'name',
        text: 'Name',
        sort: true,
      },
      {
        dataField: 'email',
        text: 'Email',
        sort: true,
      },
      {
        dataField: 'button',
        text: 'Actions',
        formatter: this.actionsButtonFormatter,
      },
    ];

    const defaultSorted = [
      {
        dataField: 'created_at',
        order: 'desc',
      },
    ];

    const subscribedUsersList = subscribedUsers && (
      <div className="postsTable mb-7">
        <BootstrapTable
          bootstrap4
          keyField="subscribedusersUid"
          data={subscribedUsers}
          loading={true}
          columns={columns}
          defaultSorted={defaultSorted}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    return (
      <>
        <Form
          name="subscribedUserForm"
          onSubmit={this.handleSaveSubscriber}
          ref={(el) => (this.subscribedUserForm = el)}
          className="mb-4"
        >
          <Row className="align-items-center">
            <Col lg={5} md={8} xs={10}>
              {/* <Row className="align-items-center"> */}
              <Form.Group
                as={Row}
                className="align-items-center mb-3"
                controlId="subscriberName"
              >
                <Col md={1} xs={2}>
                  <Form.Label>Name</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="name"
                    onChange={this.handleInputChange.bind(
                      this,
                      'subscribedUser'
                    )}
                    value={this.state.subscribedUser.name || ''}
                  />
                  <div className="errorMsg mb-0">
                    {this.state.errors['name']}
                  </div>
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="align-items-center"
                controlId="subscriberEmail"
              >
                <Col md={1} xs={2}>
                  <Form.Label>Email</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="email"
                    onChange={this.handleInputChange.bind(
                      this,
                      'subscribedUser'
                    )}
                    value={this.state.subscribedUser.email || ''}
                  />
                  <div className="errorMsg mb-0">
                    {this.state.errors['email']}
                    {this.state.errors['invalid_email']}
                  </div>
                </Col>
              </Form.Group>
            </Col>
            <Col>
              {!this.state.editSubscriber ? (
                <button
                  type="submit"
                  disabled={this.state.isSaving}
                  className="btn lh-0 btn-primary h2 p-3 rounded-circle"
                >
                  <i
                    className={cx('fa fa-w-16 fa-plus', {
                      'd-none': this.state.isSaving,
                    })}
                  />
                  <utilService.BorderSpinner loading={this.state.isSaving} />
                </button>
              ) : (
                <>
                  <button
                    type="submit"
                    disabled={this.state.isSaving}
                    class="btn btn-primary font-weight-600 px-6 py-3 text-uppercase mr-4"
                  >
                    {!this.state.isSaving ? 'Save' : 'Save...'}
                  </button>
                  <button
                    type="button"
                    onClick={this.onReset.bind(this, 'subscribedUserForm')}
                    class="btn btn-secondary font-weight-600 px-6 py-3 text-uppercase mr-4"
                  >
                    Cancel
                  </button>
                </>
              )}
              {/* <button
                    className="bg-dark filter-btn"
                    onClick={this.onReset.bind(this, 'subscribedUserForm')}
                  >
                    Reset
                  </button> */}
            </Col>
          </Row>
        </Form>
        <div className="filters mb-2">
          {/* <form name="filterFormRef" ref={(el) => (this.filterFormRef = el)}> */}
          <h2>Filters</h2>
          <Form
            name="filterFormRef"
            onSubmit={this.handleSaveSubscriber}
            ref={(el) => (this.filterFormRef = el)}
            className="mb-4"
          >
            <Row>
              <Col md={6}>
                <Form.Group controlId="filterBySubscriberName">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="name"
                    onChange={this.handleInputChange.bind(this, 'filterData')}
                    value={this.state.filterData.name || ''}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="filterBySubscriberEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    name="email"
                    onChange={this.handleInputChange.bind(this, 'filterData')}
                    value={this.state.filterData.email || ''}
                  />
                </Form.Group>
              </Col>
              <Col className="border-top mt-3 pt-3">
                <button
                  onClick={this.onReset.bind(this, 'filterFormRef')}
                  className="btn btn-secondary font-weight-600 px-6 py-3 text-uppercase mr-4"
                >
                  Reset
                </button>
                <button
                  onClick={this.onFilter}
                  disabled={this.state.isFiltering}
                  className="btn btn-secondary font-weight-600 px-6 py-3 text-uppercase"
                >
                  {this.state.isFiltering ? 'Filter...' : 'Filter'}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
        {this.props.subscribedUserActionLoading === true && (
          <utilService.GridSweetLoader
            loading={this.props.subscribedUserActionLoading}
          />
        )}
        {subscribedUsersList}
        <ConnectionPdfs subscribedUsers={subscribedUsers} />
        <DialogBox
          show_modal={this.state.modal_data}
          hide_modal={this.handleCloseModal.bind(this)}
          onSubmit={this.OnDialogSubmit.bind(this)}
        />
        <div className="overlay"></div>
      </>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  // console.log('state....', state);
  return {
    subscribedUserActionLoading: state.subscribedUsers.actionsloading,
    pdfActionLoading: state.subscribedUsers.pdf.actionsloading,
    token: state.user.cognito_data.token,
    error: state.subscribedUsers.error,
    user: state.user.user,
    subscribedUsers: Object.values(state.subscribedUsers.byId),
    // pdf: state.subscribedUsers.pdf.pdfObj,
    // pdfs: Object.values(state.subscribedUsers.pdf.byId),
  };
}

/**
 * Print no records found when data empty
 */
function indication() {
  return 'No records found!';
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, adminActions, portalActions), dispatch)
)(SubscribedUsers);
